export default __webpack_public_path__ + "static/media/iphone.462ed5ce.png";